export enum AvailableLanguage {
  de = 'de',
  en = 'en',
  fr = 'fr',
  it = 'it',
}
